/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentItemData } from '../../component-classes/data/component-item-data.class';
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 20 to version 21
 * - Re-centers every rule-managed vent group on its panel (GitHub #451). addPanelVents always meant
 *   to place them at x 0, but wrote through the center getter's copy, so the write never landed and
 *   a group moved by an earlier reposition kept that offset -- hanging the vent artwork off the edge
 *   of a narrow (reduced-depth) side panel.
 * - A no-op when the catalog is not loaded: the vent components can't be identified without it.
 */

const VENT_SKUS = ['VENT-SIDE', 'VENT-BACK', 'MOK-VENT-SIDE', 'MOK-VENT-BACK'];

// A saved item holds the catalog component id, or the sku itself when the component was unresolved.
const getVentItemIds = (): Set<string> => {
	const ids = new Set<string>(VENT_SKUS);

	VENT_SKUS.forEach((sku) => {
		const { id } = ComponentItemData.getDataBySku(sku) ?? {};
		if (id) ids.add(id);
	});

	return ids;
};

const centerVentGroups = (island: any, ventItemIds: Set<string>): void => {
	island?.panels?.children?.forEach((panel: any) => {
		panel?.panelItemGroups?.children?.forEach((group: any) => {
			const items = group?.items?.children ?? [];
			if (items.length === 0 || !group?.center) return;
			if (!items.every((panelItem: any) => ventItemIds.has(panelItem?.item?.id) && panelItem?.ruleManaged !== false)) return;

			group.center.x = 0;
		});
	});
};

export const u21 = (blueprint: any): any => {
	console.log('schema-update:process-update:21:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 21;

		const ventItemIds = getVentItemIds();

		updatedBlueprint.kitchens?.children?.forEach((kitchen: any) => {
			[...(kitchen?.design?.islands?.children ?? []), ...(kitchen?.design?.obstructions?.children ?? [])]
				.forEach((island: any) => centerVentGroups(island, ventItemIds));
		});

		console.log('schema-update:process-update:21:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:21:error', err);
		return null;
	}
};
